import { Typography } from '@mui/material';
import FlexContainer from 'components/FlexContainer';
import { CustomerAvatar } from 'features/customer/CustomerAvatar';
import { SidebarItem } from 'features/pageSidebar/sidebarItems/SidebarItem';
import { ComponentProps, forwardRef, ReactNode } from 'react';
import styled from 'styled-components';

type ProfileOrWorkspaceSidebarItemProps = Omit<
  ComponentProps<typeof SidebarItem>,
  'icon' | 'name'
> & {
  headline: string;
  subline: string;
  image: string | null;
  endAdornment?: ReactNode;
};

export const ProfileOrWorkspaceSidebarItem = forwardRef<
  HTMLDivElement,
  ProfileOrWorkspaceSidebarItemProps
>(({ headline, image, subline, endAdornment, ...rest }, ref) => (
  <StyledSidebarItem
    ref={ref}
    icon={<CustomerAvatar name={headline} image={image ?? undefined} size="24px" />}
    {...rest}
  >
    <FlexContainer direction="row" gap="three" justifyContent="space-between" alignItems="center">
      <TextContainer justifyContent="space-between">
        <Typography variant="body1" noWrap={true}>
          {headline}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap={true}>
          {subline}
        </Typography>
      </TextContainer>

      {endAdornment}
    </FlexContainer>
  </StyledSidebarItem>
));

const StyledSidebarItem = styled(SidebarItem)`
  // 4px space for top/bottom + 12px on the button = 16px space around the item
  // The button uses the 12px because he provides the hover effect which looks nicer with 12px
  padding-block: ${({ theme }) => theme.spacings.one};
  margin: 0;

  .MuiButtonBase-root {
    padding-inline: ${({ theme }) => theme.spacings.three};
    padding-block: ${({ theme }) => theme.spacings.two};
  }
`;

const TextContainer = styled(FlexContainer)`
  // Required to make the text overflow working
  min-width: 0;
`;
